import { ServiceCommand } from '../../../../../core/domain/command/service-command';
import { authHttpClient } from '../../../../../core/infra/http/axios-auth-http-client-adapter';
import { AUTH_API_ROUTES } from '../../api/routes';
import { CNPJValidate } from './cnpj-validate';

export const cnpjValidateService: ServiceCommand<CNPJValidate.Response> =
  new CNPJValidate(authHttpClient, AUTH_API_ROUTES.CNPJ_VALIDATE);

export type { CNPJValidate };
